import { render } from "./ListPlatforms.vue?vue&type=template&id=cb1eb0ec"
const script = {}

import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__